<template>
  <basic-container id="carFreeOpenReason20220523">
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :search.sync="searchForm"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="carFreeOpenReasonDialogOpen"
          >新 增</el-button
        >
        <el-button type="danger" size="small" icon="el-icon-delete" @click="carFreeOpenReasonDelete"
          >删 除</el-button
        >
      </template>
    </avue-crud>

    <el-dialog
      title="新增"
      :visible.sync="carFreeOpenReasonAddShow"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      @close="carFreeOpenReasonDialogClose"
      width="40%"
    >
      <div class="el-dialog-div">
        <el-form ref="addForm" :model="addForm" label-width="120px">
          <el-form-item label="车场名称" prop="spaceId">
            <selectSearch  v-model="addForm.spaceId" :dicData="spaceList"></selectSearch>
            <!-- <el-select
              v-model="addForm.spaceId"
              placeholder="请选择车场"
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="item in spaceList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="免费开闸原因" prop="openReason">
            <el-input v-model="addForm.openReason" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item>
            <el-col offset="6">
              <el-button type="primary" icon="el-icon-search" @click="carFreeOpenReasonAddSubmit"
                >保存</el-button
              >
              <el-button type="default" icon="el-icon-delete" @click="carFreeOpenReasonDialogClose"
                >返回</el-button
              >
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { add, getList, remove } from './carFreeOpenReason';
import { mapGetters } from 'vuex';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';

export default {
  data() {
    return {
      carFreeOpenReasonAddShow: false,
      addForm: {
        spaceId: '',
        openReason: '',
      },
      searchForm: {},
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      tempSpaceId: '',
      spaceList: [],
      option: {
        height: 'auto',
        calcHeight: 90,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        labelWidth: 100,
        editBtn: false,
        selection: true,
        searchShow: true,
        delBtn: false,
        searchMenuSpan: 18,
        span: 6,
        columnBtn: false,
        refreshBtn: true,
        menu: false,
        multiple: false,
        searchMultiple: false,
        filterMultiple: false,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '车场名称',
            type: 'tree',
            prop: 'parkingLotId',
            hide: true,
            editDisabled: false,
            clearable: false,
            span: 8,
            search: true,
            cell: true,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              },
            ],
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
          },
          {
            label: '车场名称',
            prop: 'spaceName',
            hide: false,
            display: false,
            addDisplay: false,
          },
          {
            label: '免费开闸原因',
            prop: 'openReason',
            span: 8,
            rules: [
              {
                required: true,
                message: '请输入免费开闸原因',
                trigger: 'change',
              },
            ],
          },
          {
            label: '创建人',
            prop: 'operateName',
            hide: false,
            display: false,
            addDisplay: false,
          },
        ],
      },
      data: [],
    };
  },

  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carFreeOpenReason_add, false),
        delBtn: this.vaildData(this.permission.carFreeOpenReason_delete, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$refs.crud.$refs.table.doLayout();
    });
  },
  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        this.option.column[1].dicData = data.data;
        this.option.column[1].searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.searchForm.parkingLotId = this.spaceList[0].id;
        this.tempSpaceId = this.spaceList[0].id;
      }
      this.onLoad();
    });
  },
  methods: {
    carFreeOpenReasonDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    carFreeOpenReasonAddSubmit() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          console.log(this.addForm);
          add(this.addForm).then(
            () => {
              console.log('submit!');
              this.carFreeOpenReasonDialogClose();
              this.$message.success('操作成功!');
              done();
            },
            (error) => {
              window.console.log(error);
            }
          );
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    carFreeOpenReasonDialogOpen() {
      this.carFreeOpenReasonAddShow = true;
      //设置默认车场
      if (this.query.parkingLotId == '') {
        this.$message.warning('请选择车场');
        return;
      }
      this.addForm.spaceId = this.query.parkingLotId;
    },
    carFreeOpenReasonDialogClose() {
      this.carFreeOpenReasonAddShow = false;
      this.onLoad();
      this.$refs['addForm'].resetFields();
      this.addForm.spaceIs = '';
      this.addForm.freeOpenReason = '';
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.searchForm = {};
      this.query = {};
      this.searchForm.parkingLotId = this.tempSpaceId;
      this.query.parkingLotId = this.tempSpaceId;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.parkingLotId == undefined || this.query.parkingLotId == '') {
        this.query.parkingLotId = this.tempSpaceId;
      }
      if (this.query.parkingLotId == '') {
        return;
      }
      this.tempSpaceId = this.query.parkingLotId;
      this.query.spaceId = this.query.parkingLotId;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style lang="scss">
#carFreeOpenReason20220523 {
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
